<template>
  <div v-if="!isKioskModeEnabled" class="pdp-add-to-cart">
    <div v-if="product.retailerOnly || !options.eCommAvailable">
      <div v-if="product.retailerOnly" class="alert negative" v-html="bp('inStoreOnly')" />
      <trek-link
        button
        primary
        block
        icon="pin_drop"
        :href="withContextPath('/store-finder/')"
        data-ga-event="find-a-store-cta"
        data-ga-category="Find a Store CTA"
        data-ga-action="Item Not Available for Purchase"
      >
        <span v-html="bp('retailerButtonCaption')" />
      </trek-link>
    </div>
    <div v-else-if="isAddToCartVisible">
      <ul class="quantityOptions">
        <li class="form__item">
          <div class="form-group w-20">
            <label for="qty" class="form-label" v-html="bp('quantity')" />
            <quantity-input id="qty" v-model="quantity" :disabled="!isPurchasable" />
          </div>
        </li>
      </ul>

      <trek-button
        id="addToCartButton"
        primary
        block
        icon="shopping_cart"
        :disabled="!isAddToCartEnabled"
        type="submit"
        class="mb-1"
        @click.prevent="addToCart"
      >
        <span id="add-button" v-html="addToCartButtonCaption" />
      </trek-button>
      <pdp-add-to-cart-status :message="message" :base-properties="baseProperties" />
    </div>
    <pdp-replacement
      v-if="product.isArchived && variantCode"
      :replacement-product="replacementProduct"
      :base-properties="baseProperties"
    />
  </div>
</template>
<script>
import PdpAddToCartStatus from '@/components/containers/pdp/PdpAddToCartStatus';
import {Url} from '@/utils/url';
import get from 'lodash/get';
import QuantityInput from '@/components/QuantityInput';
import PdpReplacement from '@/components/containers/pdp/PdpReplacement';
import {isInStockByCode, isBuildToOrderInStockByCode} from '@/components/containers/pdp/utils/retailers-helper';
import TrekButton from '@/components/TrekButton';
import TrekLink from '@/components/TrekLink';

export default {
  name: 'PdpAddToCart',
  components: {PdpReplacement, QuantityInput, PdpAddToCartStatus, TrekButton, TrekLink},
  props: {
    addToCartButtonCaption: {
      type: String,
      default: '',
    },
    variantCode: {
      type: String,
      default: '',
    },
    isAddingToCart: {
      type: Boolean,
      default: false,
    },
    stockData: {
      type: Object,
      default: () => ({}),
    },
    stockMessage: {
      type: Object,
      default: () => ({}),
    },
    product: {
      type: Object,
      required: true,
    },
    isPurchasable: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
      required: true,
    },
    message: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      quantity: 1,
    };
  },
  computed: {
    isKioskModeEnabled() {
      return this.options.kioskModeEnabledOnSite;
    },

    isAddToCartVisible() {
      return !this.product.isArchived;
    },

    isAddToCartEnabled() {
      return (
        this.isPurchasable &&
        !this.isAddingToCart &&
        (isInStockByCode(get(this.stockData, 'globalStockStatus')) ||
          isBuildToOrderInStockByCode(get(this.stockData, 'globalStockStatus')) ||
          isInStockByCode(get(this.stockMessage, 'code')) ||
          isBuildToOrderInStockByCode(get(this.stockMessage, 'code')))
      );
    },

    replacementProduct() {
      if (!this.variantCode) {
        return null;
      }

      return get(
        this.product.variants.find((variant) => variant.code === this.variantCode),
        'replacementProduct'
      );
    },
  },
  methods: {
    withContextPath: (url) => Url.withContextPath(url),
    addToCart() {
      this.$emit('add-to-cart', this.quantity);
    },
  },
};
</script>
